<div class="inline-flex items-center ml-3">
    <button
        [id]="buttonId"
        [disabled]="disabled || selectedPrinterLabel === 'Sem impressora'"
        [color]="color"
        (click)="print.emit()"
        mat-stroked-button>
        <div style="display: flex; align-items: center;">
            <mat-icon [svgIcon]="icon" class="icon-size-5 mr-2"></mat-icon>
            <!--            <span class="mr-2"-->
            <!--                  *ngIf="!isMobileResolution && selectedPrinterLabel === 'Sem impressora' && printers.length < 2 ">{{ label }}</span>-->
        </div>

        <span class="text-secondary text-sm truncate max-w-56" *ngIf="!isMobileResolution && selectedPrinterLabel">
      ({{ selectedPrinterLabel }})
    </span>
        <button style="position: relative; right: -20px; margin-left: -20px !important;"
                mat-icon-button
                [matMenuTriggerFor]="printMenu"
                (click)="$event.stopPropagation()"
                aria-label="Selecionar impressora"
                class="ml-1">
            <mat-icon [svgIcon]="'heroicons_solid:chevron-down'"></mat-icon>
        </button>
        <mat-menu #printMenu="matMenu">
            <ng-container *ngIf="printers?.length; else noPrinters">
                <button mat-menu-item *ngFor="let p of printers" (click)="choosePrinter(p)">
                    <mat-icon [svgIcon]="isSelected(p) ? 'heroicons_solid:check' : 'heroicons_outline:printer'"
                              class="mr-2"></mat-icon>
                    {{ getPrinterName(p) }}
                </button>
            </ng-container>
            <ng-template #noPrinters>
                <button mat-menu-item disabled>
                    <mat-icon [svgIcon]="'heroicons_outline:information-circle'" class="mr-2"></mat-icon>
                    Nenhuma impressora disponível
                </button>
            </ng-template>
            <button mat-menu-item (click)="openPrinterSelector()">
                <mat-icon [svgIcon]="'heroicons_outline:printer'" class="mr-2"></mat-icon>
                Selecionar impressora
            </button>
        </mat-menu>
    </button>
</div>
